import { TFundingRequirement } from './fundingRequirements.types';

// The customer can still act on it: not yet done, or it failed and needs redoing.
export const getIsFundingRequirementActionable = ({
    status
}: TFundingRequirement): boolean =>
    status === 'action_needed' || status === 'error';
